module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAKlBMVEUAAABFt/9Ft/9FuP9HuP9FuP9Ft/9Etv9FuP9EuP9Ft/9GuP9Dtv9Ft//CjYcsAAAADXRSTlMAqlWfB/TDdF1LyZYq2o6mSAAAAG1JREFUKM9jIBe4C0KAJUzA9i4UTIAKxDYpgcFeA6jAXSitK0CeAIvp3QQUAfa7aAKMN9C0MF6im4ADRKAXJrAWFh4FUIFTUH6wA1QAAZAF0tAF7uISYL4NCWCNq1ABTpiVl2GmTobGUgm50QwAmxBH7mE1GSQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/longda/copy.png
// module id = QhOY
// module chunks = 32